import React from 'react';
import PropTypes from 'prop-types';

const AutoCollect = ({ theme, fill, ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.9" clipPath="url(#clip0)">
      <path
        d="M19.1666 11.9019V16.7528C19.1666 18.0851 18.0848 19.1669 16.7525 19.1669H16.1262C16.707 19.1669 16.7639 17.5157 16.7525 16.7528V14.3159C16.7525 12.9836 17.8343 11.9019 19.1666 11.9019Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M8.07565 0.845703C8.07565 2.178 6.99388 3.25978 5.66158 3.25978H3.24751V3.63556C3.24751 3.63556 3.11086 0.845703 3.86241 0.845703H8.07565Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M16.1262 19.1668H0.833252V3.24758C0.833252 1.91528 1.91503 0.833496 3.24732 0.833496H3.86223C3.11068 0.833496 3.24732 3.62335 3.24732 3.62335V16.7527H16.7525C16.7525 17.5157 16.7069 19.1668 16.1262 19.1668Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M9.4806 2.72094C9.10715 3.00528 8.76483 3.33173 8.47437 3.70031L10.3105 4.94296C10.4557 4.785 10.6113 4.63756 10.7773 4.51119C12.157 3.47917 14.0968 3.77403 15.1134 5.17464C15.6425 5.9118 15.8396 6.83852 15.6425 7.73365L17.7898 8.21807C18.433 5.32207 16.628 2.44714 13.7753 1.79422C12.2918 1.45723 10.7151 1.79422 9.4806 2.72094Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M14.575 6.94419L13.8281 8.02887L16.5564 9.96656C17.0543 10.3141 17.739 10.1982 18.0917 9.69276L20.0004 6.92313L18.9319 6.1649C18.5273 5.88057 17.9672 5.97535 17.6871 6.38605L16.9194 7.50233L15.8198 6.72304C15.4153 6.42817 14.8655 6.52295 14.575 6.94419C14.575 6.93366 14.575 6.94419 14.575 6.94419Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M15.4983 12.0833C15.8717 11.7989 16.2141 11.4725 16.5045 11.1039L14.6684 9.86126C13.5273 11.1566 11.5667 11.2724 10.2908 10.114C9.4505 9.35577 9.08743 8.18684 9.32602 7.0811L7.17869 6.59668C6.5459 9.49268 8.34053 12.3676 11.1933 13.0205C12.6974 13.347 14.2638 13.01 15.4983 12.0833Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
      <path
        d="M10.415 7.87036L11.1619 6.78568L8.43365 4.84799C7.93571 4.50047 7.25106 4.61631 6.90873 5.12179L5 7.89142L6.06848 8.64964C6.47304 8.93398 7.03322 8.8392 7.3133 8.4285L8.08095 7.31222L9.18054 8.09151C9.56436 8.38637 10.1245 8.28106 10.415 7.87036Z"
        fill={fill || theme.GLOBAL_SIDEBAR.primaryBtn}
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

AutoCollect.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default AutoCollect;
